import gql from 'graphql-tag';

const CREATE_TASK = gql`
  mutation createTask($data: TaskCreateInput!, $mentions: [ID!]) {
    createTask(data: $data, mentions: $mentions) {
      id
      name
      createdBy {
        id
        name
        avatar {
          id
          key
        }
      }
      startDate
      dueDate
      assigneeUser {
        id
        name
      }
      assigneeUsers {
        id
        name
      }
      collaborators {
        id
        name
      }
      requestType
      requestSubType
      requestTypeDetails
      status
      channelPartner {
        id
        name
      }
      advertiser {
        id
        name
      }
      attachedFiles {
        id
        name
        url
      }
      attachedImages {
        id
        name
        url
      }
      taskDetails
      relatedCampaigns {
        id
        name
        startDate
        endDate
      }
      createdAt
      linkUrl
      urgency
      teams {
        id
        name
      }
      project {
        id
        name
      }
      projects {
        id
        name
      }
    }
  }
`;

export default CREATE_TASK;
